<template>
  <div class="container mt-2">
    <div class="row">
      <!-- Nav -->
      <div class="col-12">
        <div class="btn-group">
          <button
            class="float-start btn btn-sm btn-primary"
            @click="goBack">
            <i class="fa fa-chevron-left"/>
            Back
          </button>
        </div>
      </div>
      <!-- Header -->
      <div class="col-12">
        <CustomerHeader :customer="customer"/>
        <hr>
      </div>
      <!-- Nav tabs -->
      <div class="p-0">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item">
            <button
              class="nav-link"
              :class="subView == 'assignment' ? 'active' : ''"
              type="button"
              role="tab"
              @click="setSubView('assignment')">
              Assigned Displays
            </button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link"
              :class="subView == 'browse' ? 'active' : ''"
              type="button"
              role="tab"
              @click="setSubView('browse')">
              Available Displays
            </button>
          </li>
        </ul>      
      </div>
      <!-- Content -->
      <Assignments
        v-if="subView == 'assignment' && !loading"
        :items="items"
        :records="customerRecords"
        :customer="customer"/>
      <BrowseItems
        v-if="subView == 'browse'"
        :items="items"
        :customer="customer"
        :merchIds="merchIds"/>
      <div
        v-if="subView == 'assignment' && loading"
        class="text-center mt-5">
        <Spinner/>
      </div>
    </div>
  </div>
</template>

<script setup>
  import CustomerHeader from '../../components/CustomerHeader.vue';
  import Assignments from './assignments/Assignments.vue';
  import BrowseItems from './browseItems/BrowseItems.vue';
  import Spinner from '../../../../../../global/Spinner.vue'
  import { ref, computed, onMounted} from 'vue';
  import { useStore } from 'vuex';

  // Initialize
  const props = defineProps(['detail'])
  const emit = defineEmits(['goBack', 'deleteDetail'])
  const store = useStore()

  // LifeCycle
  onMounted(()=>{
    store.dispatch('displayTrackingGetCustomerRecords', customer.value.id)
    store.dispatch('displayTrackingGetItems')
  })

  // Data
  const confirm = ref(false)
  const subView = ref('assignment')

  // Methods
  const goBack = ()=>{
    store.dispatch('displayTrackingSetView', 'index')
  }

  const setSubView = (view)=>{
    subView.value = view
  }

  // Computed
  const customer = computed(()=>{
    return store.getters.displayTrackingCustomer
  })

  const customerRecords = computed(()=>{
    return store.getters.displayTrackingCustomerRecords
  })

  const items = computed(()=>{
    return store.getters.displayTrackingItems
  })

  const loading = computed(()=>{
    return store.getters.displayTrackingLoading
  })

  const merchIds = computed(()=>{
    return _.map(customerRecords.value, r => r.merchandisingItemId)
  })
</script>